import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

import { useCityServices } from './hooks/useCityServices';
import Loading from '../../../Common/Loading';
import { number } from '../../../Common/Util/number';
import TableComponent from '../../../Common/Charts/TableCharts';

const CityServices = ({ queryConfig }) => {
    const { chartData, isLoading } = useCityServices(queryConfig);

    if (isLoading) return <Loading />;

    const tableColumns = [
        {
            key: 'municipio',
            header: 'Município',
            headerStyle: { fontWeight: '500' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'services',
            header: 'Total de Atendimentos',
            headerStyle: { fontWeight: '500', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    const center =
        chartData?.counterByCity?.length > 0
            ? [chartData.counterByCity[0].latitude, chartData.counterByCity[0].longitude]
            : [-23.5489, -46.6388]; // fallback: São Paulo

    return (
        <div className="mapa-container-dashboards">
            <MapContainer
                center={center}
                zoom={6}
                className="leaflet-container-dashboards"
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {chartData.counterByCity.map((city, index) => (
                    <Marker
                        key={`${city.municipio}-${index}`}
                        position={[city.latitude, city.longitude]}
                        icon={
                            new L.Icon({
                                iconUrl:
                                    'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
                                shadowUrl:
                                    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png',
                                iconSize: [25, 41],
                                iconAnchor: [12, 41],
                                popupAnchor: [1, -34],
                                shadowSize: [41, 41]
                            })
                        }
                    >
                        <Popup>{city.municipio}</Popup>
                    </Marker>
                ))}
            </MapContainer>

            <TableComponent
                data={chartData.counterByCity}
                columns={tableColumns}
                title="AIH por Município de Residência"
                showTotal={true}
                totalColumn="services"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};

export default CityServices;